import { render, staticRenderFns } from "./ui-answer.vue?vue&type=template&id=b7a5c8be&scoped=true"
import script from "./ui-answer.vue?vue&type=script&lang=js"
export * from "./ui-answer.vue?vue&type=script&lang=js"
import style0 from "./ui-answer.vue?vue&type=style&index=0&id=b7a5c8be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a5c8be",
  null
  
)

export default component.exports